import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from 'components/Icons/types'

const Svg = styled.svg`
  fill: #8f8bff;
  width: 25px;
  height: 24px;
`

export const UploadIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 24" className={className}>
      <path d="M11.6899 16.175V6.9L8.68994 9.9L7.61494 8.825L12.4399 4L17.2649 8.825L16.1899 9.9L13.1899 6.9V16.175H11.6899ZM5.93994 20C5.53994 20 5.18994 19.85 4.88994 19.55C4.58994 19.25 4.43994 18.9 4.43994 18.5V14.925H5.93994V18.5H18.9399V14.925H20.4399V18.5C20.4399 18.9 20.2899 19.25 19.9899 19.55C19.6899 19.85 19.3399 20 18.9399 20H5.93994Z" />
    </Svg>
  )
}
